import "./HealingPhilosophy.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ALegacyOfHealing from "./sections/ALegacyOfHealing";
import OurExpertTeam from "./sections/OurExpertTeam";
import ByTheNumbers from "./sections/ByTheNumbers";
import Footer from "@/reusable_sections/Footer";
export default function HealingPhilosophyPage() {
  return <div>
      <MainNavigation />
      <ALegacyOfHealing />
      <OurExpertTeam />
      <ByTheNumbers />
      <Footer />
    </div>;
}